import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchVehicles = async () => {
  const { data } = await axios.get(`${API}/vehicles`);
  return data;
};

export const fetchVehicle = async (stock) => {
  const { data } = await axios.get(`${API}/vehicles/${stock}`);
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await axios.post(`${API}/contact`, payload);
  return data;
};
